module.exports = __webpack_public_path__ + "static/media/check_mark_white.c728ebd2.svg";